import { toast } from "sonner";
import React from "react";
import { X } from "lucide-react";

export function toastMessage(
  status: "success" | "error" | "info",
  message: string,
) {
  const baseConfig = {
    duration: 4000,
    action: {
      label: <X size={16} />,
      onClick: () => toast.dismiss(),
    },
  };

  switch (status) {
    case "success":
      toast.success(message, baseConfig);
      break;
    case "error":
      toast.error(message, baseConfig);
      break;
    case "info":
      toast(message, baseConfig); // `toast()` is default/info style
      break;
    default:
      toast(message, baseConfig);
  }
}
